/**
 * Collection of urls to different api endpoints.
 */
export const api = {
    productData: "https://ibog30.gyldendal.dk/addin/api/interim.asmx/GetLibrary?includeEmbedded=false&includeMobileblocked=true",
};
